import type { QueueItem } from '@/lib/types';

/**
 * Builds the subtitle line for a queue row.
 *
 * Priority order (per design MPracticeActive / DPractice queue rail):
 *   1. composer + parts + structure → "Traditional · 2 parts · AABB"
 *   2. composer + parts            → "Traditional · 2 parts"
 *   3. parts + structure           → "2 parts · AABB"
 *   4. composer only               → "Traditional"
 *   5. structure only              → "AABB"
 *   6. parts only                  → "2 parts"
 *   7. none of the above           → fall back to formName · keyName (or null)
 */
export function queueRowSubtitle(item: QueueItem): string | null {
  const { composerName, partsCount, structurePattern } = item;

  if (partsCount !== null || structurePattern !== null || composerName !== null) {
    const parts: string[] = [];
    if (composerName !== null) parts.push(composerName);
    if (partsCount !== null) parts.push(`${partsCount} parts`);
    if (structurePattern !== null) parts.push(structurePattern);
    return parts.join(' · ');
  }

  const fallbackParts = [item.formName, item.keyName].filter(Boolean);
  return fallbackParts.length > 0 ? fallbackParts.join(' · ') : null;
}
